import axios from 'axios';

export const wishlistService = {
    getWishlistItemsService: (params) => axios.get('/wishlist', { auth: true, params: { ...params } }),

    getWishlistItemByIdService: (id) => axios.get(`/wishlist/${id}`, { auth: true }),

    getWishlistUpdatesCountService: () => axios.get('/wishlist/updates/count', { auth: true }),

    markWishlistSeenService: (id) => axios.patch(`/wishlist/${id}/seen`, null, { auth: true }),

    createWishlistItemService: (body) => axios.post('/wishlist', body, { auth: true }),

    editWishlistItemService: (id, body) => axios.patch(`/wishlist/${id}`, body, { auth: true }),

    deleteWishlistItemService: (id) => axios.delete(`/wishlist/${id}`, { auth: true }),
};
